module.exports = __webpack_public_path__ + "img/coupon-close-icon.223c0734.svg";